import { render } from "./AppButton.vue?vue&type=template&id=10196bf4&scoped=true"
import script from "./AppButton.vue?vue&type=script&lang=js"
export * from "./AppButton.vue?vue&type=script&lang=js"

import "./AppButton.vue?vue&type=style&index=0&id=10196bf4&lang=scss&scoped=true"

import exportComponent from "/Users/intr0vert/Git/ai-startup/aibanner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10196bf4"]])

export default __exports__